export default {
  mock: {
    config: {},
    headers: {},
    status: 400,
    statusText: '',
    data: {
      errors: [
        {
          code: "xxxxx",
          message: "xxxxx"
        }
      ]
    }
  }
}

/*
---------------------
エラーコード : エラーメッセージ
---------------------

E0000 : 予期せぬエラーが発生しました
E1001 : {リクエストパラメータ名}が設定されていません
E1002 : {リクエストパラメータ名}の値が正しくありません
E1003 : {リクエストパラメータ名}の型が正しくありません
E1004 : {リクエストパラメータ名}の形式が正しくありません
E1005 : {リクエストパラメータ名}の文字数は入力制限値を超えています
E1006 : {リクエストパラメータ名}は重複データを含んでいます

E2001 : ユーザーIDまたはパスワードが正しくないため、ログインに失敗しました
E2002 : 実行権限がありません
E2003 : {動作}に失敗しました
E2004 : {動作}は完了していません
E2005 : {動作}はすでに完了しています
E2006 : {無効化できない理由}ため無効化できません
E2007 : 削除済みのため{データ名}が削除できません
E2008 : {データ名}が存在しません
E2009 : {データ名}が無効になっています
E2010 : {データ名}がすでに登録されております
E2011 : {データ名}の登録に失敗しました
E2012 : {データ名}の取得に失敗しました
E2013 : {データ名}の更新に失敗しました
E2014 : {データ名}の削除に失敗しました

E4001 : APIキー認証が失敗しました
E4002 : アクセストークン認証が失敗しました
E4003 : アクセストークンの有効期限が切れました
E4004 : ユーザ認証情報は正しくありません
E4401 : HTTP認証が失敗しました
E4402 : 要求されたHTTPメソードはサポートしません
E4403 : 要求されたエンドポイントは存在しません

E5001 : DB接続エラー
E5002 : DB操作エラー
*/